import helpers from '../common/helpers';
// import { each } from 'jquery';

(function ($) {
  "use strict";

  window.cnts = {}

  cnts.windowWidth = $(window).width();
  cnts.windowHeight = $(window).height();
  cnts.body = $('body');
  cnts.html = $('html');
  cnts.scroll = 0;
  cnts.checkString = false;

  const cntsGeneral = {
    init: function () {
      this.setup();
      this.start();
    },
    setup() {
      this.options = {
        $owlPostFullBanner: $('#owl-full-banner'),
        $owlPostCardsFeed: $('.owl-post-cards')
      };
    },
    start() {
      feather.replace();
      cntsGeneral.customComponents();
      cntsGeneral.carouselFullBanner();
      cntsGeneral.carouselPostCards();

      if(helpers.isMobile() && cnts.windowWidth <= '992') {
       cntsGeneral.navFooter();
      }

    },
    customComponents: function () {
      $('.collapse').on('show.bs.collapse', function () {
        let $el = '';
        if ($(this).parent('.accordion-child').length < 1) {
          $el = $('.accordion-parent');
        } else {
          $el = $('.accordion-child');
        }

        $el.removeClass('accordion--active');
        $(this).parent().addClass('accordion--active');
      });


      // custom class active
      $(".form-custom-checkbox input").on("click", (element) => {
        const $this = $(element.currentTarget);

        if ($this.is(':checked')) {
          $(".form-custom-checkbox").removeClass('active');
          $this.parent().addClass('active');
        }
      })

      $(".open-new-tab").on("click", (element) => {
        let srcImage = $(event.currentTarget).find('img').attr('src');
        window.open(srcImage);
      })
      // if (!cnts.checkString) {
      //   $('body').html(function (index, html) {
      //     // console.log(index, html);
      //     let replaceWith = '<span class="centrus-custom">Centrusprev<sup>+</sup><span>';
      //     return html.replace('Centrusprev+', replaceWith);
      //   });

      //   cnts.checkString = true;
      // }

      // element to detect scroll direction of
      var $el = $(window);

      // initialize last scroll position
      var lastY = $el.scrollTop();

      $el.on("scroll", function () {
        var currY = $el.scrollTop();

        var y = currY > lastY ? "down" : currY === lastY ? "none" : "up";

        if (y === "down") {
          $("#js-header").removeClass("fixed-top");
          $("main").removeClass("margin-top");
        }

        if (y === "up" && currY > 190) {
          $("#js-header").addClass("fixed-top");
          $("main").addClass("margin-top");
        }

        lastY = currY;
      });
    },
    carouselFullBanner() {
      const { $owlPostFullBanner } = this.options;

      $owlPostFullBanner.owlCarousel({
        center: true,
        loop: true,
        // margin: 2,
        nav: false,
        dots: true,
        stagePadding: 0,
        items: 1
      })
    },
    carouselPostCards() {
      const { $owlPostCardsFeed } = this.options;


      if ($owlPostCardsFeed.length > 0) {

        $owlPostCardsFeed.each(function () {
          let $this = $(this);

          if ($('body').hasClass('cnts--mobile')) {
            $this.owlCarousel({
              center: false,
              loop: true,
              // margin: 2,
              nav: false,
              dots: true,
              stagePadding: 50,
              // items: 1,
              responsive: {
                0: {
                  items: 1
                },
                768: {
                  items: 2
                }
              }
            })

          } else {
            $this.owlCarousel('destroy');
            $this.removeClass('owl-carousel owl-theme');
          }
        })
      }
    },
    navFooter(){

      $(".footer-menu__title").on("click", (element) => {
        let next = $(event.currentTarget).next();
        console.log(next, next.is(':visible'));

        if(next.is(':visible')){
          next.slideUp();
          console.log('if')
        } else {
          console.log('else')
          $('.footer-menu__items').slideUp();
          next.slideDown();
        }
      })
    }
  };

  $(document).ready(function () {
    cntsBrowserDetection.init();
    cntsGeneral.init();
  });

  $(window).resize(function () {
    cnts.windowWidth = $(window).width();
    cnts.windowHeight = $(window).height();

    cntsBrowserDetection.init();
  });

  /*
   * Browser detection functionality
   */
  const cntsBrowserDetection = {
    init: function () {
      cntsBrowserDetection.addBodyClassName();
    },
    isBrowser: function (name) {
      let isBrowser = false;

      switch (name) {
        case 'chrome':
          isBrowser = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
          break;
        case 'safari':
          isBrowser = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
          break;
        case 'firefox':
          isBrowser = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
          break;
        case 'ie':
          isBrowser = window.navigator.userAgent.indexOf("MSIE ") > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
          break;
        case 'edge':
          isBrowser = /Edge\/\d./i.test(navigator.userAgent);
          break;
      }

      return isBrowser;
    },
    addBodyClassName: function () {
      const browsers = [
        'chrome',
        'safari',
        'firefox',
        'ie',
        'edge',
      ];

      $.each(browsers, function (key, value) {
        if (cntsBrowserDetection.isBrowser(value) && typeof cnts.body !== 'undefined') {
          if (value === 'ie') {
            value = 'ms-explorer';
          }
          cnts.body.addClass('cnts-browser--' + value);
        }
      });

      if (helpers.isMobile() && cnts.windowWidth < '992') {
        $('body').removeClass('cnts--desktop').addClass('cnts--mobile');

      } else {
        $('body').removeClass('cnts--mobile').addClass('cnts--desktop');
      }
    }
  };
})(jQuery);